<template>
  <!-- 新建客户信息 -->
  <a-modal
    :title="title"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    width="52%"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div>
      <a-form-model
        ref="formRef"
        :model="form"
        labelAlign="right"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :rules="formRules"
      >
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              label="客户名称"
              prop="companyName"
              :labelCol="rowLabel"
              :wrapperCol="rowWrapper"
            >
              <a-input v-model="form.companyName" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="title===`[修改]${this.$tree([], 'customerManage/index')}`">
          <a-col :span="24">
            <a-form-model-item label="下属联系人" :labelCol="rowLabel" :wrapperCol="rowWrapper">
              <span>{{form.customerName}}</span>
              <a-button
                type="primary"
                size="small"
                @click="addLinkNameClick"
                style="margin-left: 20px;"
              >添加联系人</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="单位地址" :labelCol="rowLabel" :wrapperCol="rowWrapper">
              <a-input v-model="form.address" placeholder="请输入单位地址" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="客户种类" prop="customerType">
              <a-select
                @change="typeChange"
                v-model="form.customerType"
                placeholder="请选择客户种类"
                style="width: 100%;"
              >
                <a-select-option
                  v-for="(item,index) in clientType"
                  :key="index"
                  :value="item.label"
                >{{item.value}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="上级客户/供应商" :labelCol="rowLabel" :wrapperCol="rowWrapper">
              <a-input
                v-model="form.upperCustomerName"
                placeholder="点击选择上级客户/供应商"
                read-only
                class="choosePerson"
                @click="openModal('supplier')"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="title===`[新建]-${this.$tree([], 'customerManage/index')}`">
          <a-col :span="12">
            <a-form-model-item label="姓名">
              <a-input v-model="form.name" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="手机" prop="phone">
              <a-input v-model="form.phone" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="title===`[新建]-${this.$tree([], 'customerManage/index')}`">
          <a-col :span="12">
            <a-form-model-item label="部门" prop="dept">
              <a-input v-model="form.dept" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="职务" prop="duty">
              <a-input v-model="form.duty" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="收款人名称">
              <a-input v-model="form.payeeName" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="银行帐号">
              <a-input v-model="form.bankAccount" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="银行名称">
              <a-input v-model="form.bankName" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="上传附件" :labelCol="rowLabel" :wrapperCol="rowWrapper">
              <upload-attachment ref="uploadRef" :val-name="valName" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <public-dialog
      :title="publicDia.title"
      :dialog-visible="publicDia.visible"
      :component-name="publicDia.comName"
      @logSuccess="publicDialogSucc"
      @cancel="publicDialogCancel"
    />
    <personnel
      :visible="personVisible"
      :chooseData="personData"
      :isOnce="isOncePerson"
      @close="personClose"
      @success="personSuccess"
    />
    <link-name-add
      ref="linkNameRef"
      :title="`[新建]-${this.$tree([], 'customerManage/linkName/index')}`"
      :dialog-visible="linkNameVisible"
      @success="linkAddSucc"
      @close="linkAddClose"
    />
    <template #footer>
      <a-button @click="handleCancel" style="background-color:#F2F2F2">取消</a-button>
      <a-button type="primary" :loading="loading" @click="handleOk">保存</a-button>
    </template>
  </a-modal>
</template>

<script>
import personnel from '@/components/personnel'
import uploadAttachment from '../common/Upload'
import { getNowFormatDate } from '@/utils/timer'
import publicDialog from '@/components/modelDialog/publicDialog.vue'
import linkNameAdd from './linkName/addEdit.vue'
export default {
  name: 'AddEdit',
  components: { personnel, uploadAttachment, publicDialog, linkNameAdd },
  provide () {
    return {
      formData: this,
      type: true
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    clientType: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      publicDia: { visible: false },
      form: {},
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      rowLabel: { span: 3 },
      rowWrapper: { span: 19 },
      loading: false,
      formRules: {
        companyName: [
          { required: true, message: '请输入客户名称', trigger: 'blur' }
        ],
        customerType: [
          { required: true, message: '请选择客户种类', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' }
        ]
        /* phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ], */
        /* dept: [
          { required: true, message: '请输入部门', trigger: 'blur' }
        ],
        duty: [
          { required: true, message: '请输入职务', trigger: 'blur' }
        ] */
      },
      // 选择人员
      personVisible: false,
      personData: {},
      isOncePerson: true,
      uploadFileList: [],
      valName: 'uploadFileList',
      linkNameVisible: false
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.handleCancel()
      }
    }
  },
  methods: {
    addLinkNameClick () {
      this.linkNameVisible = true
      this.$nextTick(() => {
        this.$refs.linkNameRef.setCustomer(this.form)
      })
    },
    linkAddSucc (val) {
      this.linkNameVisible = false
      if (this.form.customerName) {
        this.form.customerName += `、${val.linkmanName}(${val.linkmanTel === null || val.linkmanTel === undefined ? '暂无电话' : val.linkmanTel})`
      } else {
        this.form.customerName = `${val.linkmanName}(${val.linkmanTel === null || val.linkmanTel === undefined ? '暂无电话' : val.linkmanTel})`
      }
    },
    linkAddClose () {
      this.linkNameVisible = false
    },
    getNowFormatDate,
    getRNG () {
      let number5 = Math.floor(Math.random() * 90000) + 10000
      let timeStr = this.getNowFormatDate()
      return `KH${timeStr}${number5}`
    },
    typeChange (val) {
      this.form.customerType = val
    },
    openModal (type) { // 弹窗选择一行数据
      this.publicDia.visible = true
      this.publicDia.title = '选择上级客户/供应商'
      this.publicDia.comName = 'customerManage'
    },
    publicDialogSucc (data, typeVal) { // 数据选择成功-赋值
      this.form.upperCustomer = data.companyName
      this.$set(this.form, 'upperCustomerId', data.id)
      this.$set(this.form, 'upperCustomerName', data.companyName)
      // 清楚校验
      // this.$refs.formRef.clearValidate('upperCustomerName')
      this.publicDia.visible = false
    },
    publicDialogCancel () { // 取消选择数据
      this.publicDia.visible = false
    },
    setForm (formValue) {
      this.form = { ...formValue }
      // 是否有下属联系人
      if (this.form.linkmanList !== [] && this.form.linkmanList.length > 0) {
        let linkList = this.form.linkmanList
        let str = ''
        for (let k = 0; k < linkList.length; k++) {
          if (k !== linkList.length - 1) {
            str = str + `${linkList[k].linkmanName}(${linkList[k].linkmanTel === null ? '暂无电话' : linkList[k].linkmanTel})、`
          } else {
            str = str + `${linkList[k].linkmanName}(${linkList[k].linkmanTel === null ? '暂无电话' : linkList[k].linkmanTel})`
          }
        }
        this.form.customerName = str
      }
      // 是否有附件
      if (this.form.fileIds) {
        // string 转 数组  循环获取附件信息
        let fileList = this.form.fileIds.split(',')
        this.$nextTick(() => {
          this.$refs.uploadRef.getFile(fileList)
        })
      }
    },
    handleOk () {
      this.$refs.formRef.validate((valid) => {
        // setCount字段代表是否对图片进行删除/上传操作，为0时附件未发生变化则无需赋值
        if (this.$refs.uploadRef.setCount !== 0) {
          this.form.fileIds = this.uploadFileList
        }
        if (valid) {
          this.loading = true
          if (this.title === `[新建]-${this.$tree([], 'customerManage/index')}`) {
            // 信息分为两部分  客户信息、联系人信息 所需分开添加
            // 客户信息
            this.form.type = 1
            this.form.customerCode = this.getRNG()
            this.$post('/customer/add', this.form).then(res => {
              if (res.data.status === 1) {
                this.$message.success(res.data.message)
                // 联系人信息
                const linkObj = {
                  customerId: res.data.data.id,
                  linkmanName: this.form.name,
                  linkmanDuty: this.form.duty,
                  linkmanTel: this.form.phone,
                  linkmanDept: this.form.dept,
                  customerType: 1
                }
                this.addLink(linkObj)
              } else {
                this.$message.warning(res.data.message)
                setTimeout(() => {
                  this.loading = false
                }, 200)
              }
            })
          } else {
            this.$post('/customer/update', this.form).then(res => {
              if (res.data.status === 1) {
                this.$message.success(res.data.message)
                this.$emit('success')
                this.resetForm()
              } else {
                this.$message.warning(res.data.message)
              }
            }).finally(r => {
              setTimeout(() => {
                this.loading = false
              }, 200)
            })
          }
        }
      })
    },
    addLink (linkForm) { // 添加联系人
      if (linkForm.linkmanName || linkForm.linkmanDuty || linkForm.linkmanTel || linkForm.linkmanDept) {
        this.$post('/linkman/add', linkForm).then(res => {
          if (res.data.status === 1) {
            this.$emit('success')
            this.resetForm()
            this.$message.success(res.data.message)
          } else {
            this.$message.warning(res.data.message)
          }
        }).finally(r => {
          setTimeout(() => {
            this.loading = false
          }, 200)
        })
      } else {
        // 调用完接口后再刷新首页数据
        this.$emit('success')
        this.resetForm()
      }
    },
    resetForm () {
      this.uploadFileList = []
      this.loading = false
      setTimeout(() => {
        this.form = {}
      }, 500)
    },
    handleCancel () {
      this.resetForm()
      this.$emit('close')
    },
    openPerson (name, id) {
      this.personVisible = true
      this.personData = { userId: id, userName: name }
    },
    personClose () {
      this.personVisible = false
    },
    personSuccess (data, type) {
      if (type === 'radioType') {
        this.form.upperCustomerName = data.username
        this.form.upperCustomerId = data.userId
      }
      this.personVisible = false
    }
  }
}
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/views/customerManage/addEdit.vue